import { FC, PropsWithChildren } from 'react';
import { Stack } from '@mui/material';

interface SplitColumnWrapperProps { }

const SplitColumnWrapper: FC<PropsWithChildren<SplitColumnWrapperProps>> = ({ children }) => {
  return (
    <Stack
      direction='row'
      spacing={2}
      useFlexGap
      flexWrap="wrap"
      width='100%'
      sx={{ '*': { flex: 1 } }}>
      {children}
    </Stack>
  );
}

export default SplitColumnWrapper;
